/**
 * @file index.tsx
 *
 * @fileoverview Shows a card with resume completness information.
 */
import { ReactNode } from "react";
import Grid from "../../../02-atoms/06-layout/04-grid";
import Cell from "../../../02-atoms/06-layout/04-grid/01-cell";
import Spacing from "../../../02-atoms/06-layout/07-spacing";
import Box from "../../../02-atoms/07-box";
import Avatar from "../../../02-atoms/12-user/01-avatar";
import { AvatarProps } from "../../../03-molecules/05-user/01-teaser";
import styles from "./resumeTeaser.module.scss";

export type ResumeTeaserProps = AvatarProps & {
  /**
   * The resume title.
   */
  name: string;
  /**
   * How complete is the user profile.
   */
  profileHeader: ReactNode;
  /**
   * Fields that will be shown bellow the title.
   */
  fields?: ReactNode;
  /**
   * Resume actions in the form of buttons or other.
   */
  actions?: ReactNode;
};

/**
 * The resume teaser can be used to show resumes in the resume search or on other featured places where a small portion of the resume
 * shoule be shown.
 */
export function ResumeTeaser({
  picture,
  name,
  profileHeader,
  fields,
  actions,
}: ResumeTeaserProps) {
  return (
    <Box className={`${styles.resumeTeaserWrapper} jcl-resume-teaser`}>
      <Grid className={styles.resumeTeaserGrid}>
        <Cell className={styles.avatarCell}>
          <Avatar title={name} alt={name} src={picture} />
        </Cell>
        <Cell>
          <div className={styles.resumeTeaserTitle}>{profileHeader}</div>
          <Spacing size="medium" />
          {fields}
        </Cell>
        {actions && (
          <Cell
            display="grid"
            justifyContent={["start", "end"]}
            alignItems="start"
          >
            {actions}
          </Cell>
        )}
      </Grid>
    </Box>
  );
}
export default ResumeTeaser;
